import { useState } from "react";
import { useTranslation } from "react-i18next";
import ChatWidget from "./ChatWidget";
import FeedbackModal from "./FeedbackModal";
import styles from "./ChatSupportLauncher.module.css";
import { RxCross2 } from "react-icons/rx";
import { clevertap_bot_icon_click } from "../../lib/clevertap-events";

const FEEDBACK_SHOWN_KEY = "chatbot_feedback_shown";

export default function ChatSupportLauncher() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [showHint, setShowHint] = useState(true);
  const [showFeedback, setShowFeedback] = useState(false);

  function handleOpenChat() {
    clevertap_bot_icon_click();
    setShowFeedback(false);
    setOpen(true);
  }

  function handleCloseChat() {
    // While the feedback popup is open, only its Skip/Submit can close the
    // chat, so a backdrop tap can't bypass the feedback.
    if (showFeedback) return;


    if (localStorage.getItem(FEEDBACK_SHOWN_KEY)) {
      setOpen(false);
      return;
    }

    setShowFeedback(true);
  }

  // Called after Skip or Submit, so the flag is only set once the user has
  // actually responded to the feedback popup.
  function handleFeedbackDone() {
    localStorage.setItem(FEEDBACK_SHOWN_KEY, "1");
    setShowFeedback(false);
    setOpen(false);
  }

  return (
    <>
      {open && (
        <>
          <div className={styles.backdrop} onClick={handleCloseChat} />
          <div className={styles.panel} role="dialog"
            aria-label={t("chatSupportLauncher.text_3")}
          >
            <div className={styles.dragHandle} />
            <ChatWidget onClose={handleCloseChat} />
            {showFeedback && <FeedbackModal onDone={handleFeedbackDone} />}
          </div>
        </>
      )}

      {!open && (
        <div className={styles.launcherWrap}>
          {showHint && (
            <div className={styles.hintBubble}>
              <span>{t("chatSupportLauncher.text_1")}</span>
              <button
                type="button"
                className={styles.hintClose}
                onClick={() => setShowHint(false)}
                aria-label={t("chatSupportLauncher.text_2")}
              >
                <RxCross2 />
              </button>
            </div>
          )}

          <button
            type="button"
            className={styles.launcherBtn}
            onClick={handleOpenChat}
            aria-label={t("chatSupportLauncher.text_3")}
            title={t("chatSupportLauncher.text_3")}
          >
            <img
              src="/chat-support-icon.png"
              alt=""
              className={styles.launcherIcon}
            />
          </button>
        </div>
      )}
    </>
  );
}
